import { constantRoutes } from '@/router'

const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  userinfo: state => state.user.userinfo,
  permissionRoutes: () => constantRoutes,
  teamToken: state => state.user.team_token,
  teamSelected: state => state.user.team_selected,
  teamList: state => state.user.team_list
}
export default getters
